import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatRelatedApi } from '@/api/scopes'
import type { RelatedApi } from '@/types'

/** doc_url 为空时不展示。悬停列出 [API] / [事件] 名称 */
export default function RelatedApisPopover({
  apis,
  docUrl,
}: {
  apis: RelatedApi[]
  docUrl?: string
}) {
  const { t } = useTranslation()
  if (!docUrl) return null

  const label = (
    <a
      href={docUrl}
      target="_blank"
      rel="noreferrer"
      style={{ color: '#6366F1', fontWeight: 500, whiteSpace: 'nowrap' }}
    >
      {t('scope.relatedApis')}
    </a>
  )

  if (apis.length === 0) return label

  return (
    <Popover
      trigger="hover"
      placement="topLeft"
      content={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: 360 }}>
          {apis.map((api, index) => (
            <div key={`${formatRelatedApi(api)}-${index}`} style={{ fontSize: 12, lineHeight: '18px' }}>
              {formatRelatedApi(api)}
            </div>
          ))}
        </div>
      }
    >
      {label}
    </Popover>
  )
}
